import PropTypes from "prop-types";
import { useEffect, useState } from "react";

// Helpers
import { clone } from "@Common/helpers/Modifiers/formatters";

// Components
import LineInputsLoader from "@Layouts/components/Skeletons/LineInputsLoader";
import InputValue from "@/Layouts/components/InputComponents/InputValue";

// MUI
import { Grid, Stack, Typography } from "@mui/material";

function AutoAlerts(props) {
	const {
		sectionId = "autoAlerts",
		content = null,
		useSectionsErrors = null,
		loading = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	// Used to add errors to the pay plan context
	const { addSectionError, removeSectionError, clearSectionErrors } = useSectionsErrors?.() || {};

	const [innerAlerts, setInnerAlerts] = useState({
		new: null,
		preOwned: null,
	});

	const handleUpdateInput = (area, value) => {
		const update = { ...innerAlerts };
		update[area]["value"] = value ? Number(value) : 0;

		const isValid = Boolean(update?.new?.value) && Boolean(update?.preOwned?.value);
		isValid ? removeSectionError?.(sectionId) : addSectionError?.(sectionId);

		setInnerAlerts(update);

		if (isValid) {
			onActionUpdate?.(sectionId, null, update);
		}
	};

	useEffect(() => {
		const isValid = Boolean(content?.new?.value) && Boolean(content?.preOwned?.value);
		if (!isValid) {
			addSectionError?.(sectionId);
		}

		setInnerAlerts(clone(content));

		return () => {
			setInnerAlerts({
				new: null,
				preOwned: null,
			});
			clearSectionErrors?.(sectionId);
		};
	}, [content, sectionId, addSectionError, clearSectionErrors]);

	return (
		<Grid container direction="column" px={"32px"}>
			<Grid item mt={"15px"}>
				{loading ? (
					<LineInputsLoader title justifyContent={"flex-start"} mt={0} />
				) : (
					<Grid container direction="row" columnSpacing={4} justifyContent="flex-start">
						{Boolean(innerAlerts?.new) && (
							<Grid item>
								<Grid container direction="column" alignItems="center">
									<Grid item>
										<Typography className="draw-label">New</Typography>
									</Grid>
									<Grid item className="draw-container">
										<Stack style={{ width: "95px" }}>
											<InputValue
												data={[
													{
														type: "Dollar",
														max: 9999,
														min: 0,
														decimals: 2,
													},
												]}
												value={innerAlerts.new?.value || 0}
												error={!innerAlerts.new?.value}
												readOnly={readOnly}
												onActionUpdate={(value) => handleUpdateInput("new", value)}
											/>
										</Stack>
									</Grid>
								</Grid>
							</Grid>
						)}
						{Boolean(innerAlerts?.preOwned) && (
							<Grid item>
								<Grid container direction="column" alignItems="center">
									<Grid item>
										<Typography className="draw-label">Pre-Owned</Typography>
									</Grid>
									<Grid item className="draw-container">
										<Stack style={{ width: "95px" }}>
											<InputValue
												data={[
													{
														type: "Dollar",
														max: 9999,
														min: 0,
														decimals: 2,
													},
												]}
												value={innerAlerts.preOwned?.value || 0}
												error={!innerAlerts.preOwned?.value}
												readOnly={readOnly}
												onActionUpdate={(value) => handleUpdateInput("preOwned", value)}
											/>
										</Stack>
									</Grid>
								</Grid>
							</Grid>
						)}
					</Grid>
				)}
			</Grid>
		</Grid>
	);
}
AutoAlerts.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.shape({
		new: PropTypes.object,
		preOwned: PropTypes.object,
	}),
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};

export default AutoAlerts;
